module.exports = __webpack_public_path__ + "media/stockholm/station-95c38efc.jpg";